var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2236_5512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8 1.84752C24.9658 1.17446 25.5487 0.837932 26.1684 0.706212C26.7167 0.589666 27.2833 0.589666 27.8316 0.706212C28.4513 0.837932 29.0342 1.17446 30.2 1.84752L47.1827 11.6525C48.3485 12.3255 48.9313 12.6621 49.3553 13.1329C49.7304 13.5495 50.0137 14.0402 50.1869 14.5733C50.3827 15.1759 50.3827 15.8489 50.3827 17.195L50.3827 36.805C50.3827 38.1511 50.3827 38.8241 50.1869 39.4267C50.0137 39.9598 49.7304 40.4505 49.3553 40.8671C48.9313 41.3379 48.3485 41.6745 47.1827 42.3475L30.2 52.1525C29.0342 52.8255 28.4513 53.1621 27.8316 53.2938C27.2833 53.4103 26.7167 53.4103 26.1684 53.2938C25.5487 53.1621 24.9658 52.8255 23.8 52.1525L6.81731 42.3475C5.65154 41.6745 5.06865 41.3379 4.64473 40.8671C4.26965 40.4505 3.98631 39.9598 3.81309 39.4267C3.61731 38.8241 3.61731 38.1511 3.61731 36.805L3.61731 17.195C3.61731 15.8489 3.61731 15.1759 3.81309 14.5733C3.98631 14.0402 4.26965 13.5495 4.64473 13.1329C5.06865 12.6621 5.65154 12.3255 6.81731 11.6525L23.8 1.84752Z",
    fill: "url(#paint0_linear_2236_5512)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.05 2.28053C25.245 1.59061 25.7485 1.30663 26.2723 1.19529C26.7521 1.09331 27.2479 1.09331 27.7277 1.19529C28.2515 1.30663 28.755 1.59061 29.95 2.28053L46.9327 12.0855C48.1277 12.7754 48.6253 13.0695 48.9837 13.4674C49.3119 13.8319 49.5598 14.2614 49.7114 14.7278C49.8769 15.2372 49.8827 15.8152 49.8827 17.195L49.8827 36.805C49.8827 38.1848 49.8769 38.7628 49.7114 39.2722C49.5598 39.7386 49.3119 40.1681 48.9837 40.5326C48.6253 40.9305 48.1277 41.2246 46.9327 41.9145L29.95 51.7195C28.755 52.4094 28.2515 52.6934 27.7277 52.8047C27.2479 52.9067 26.7521 52.9067 26.2723 52.8047C25.7485 52.6934 25.245 52.4094 24.05 51.7195L7.06731 41.9145C5.87233 41.2246 5.37466 40.9305 5.01631 40.5326C4.68811 40.1681 4.44018 39.7386 4.28862 39.2722C4.12312 38.7628 4.11731 38.1848 4.11731 36.805L4.11731 17.195C4.11731 15.8152 4.12312 15.2372 4.28862 14.7278C4.44018 14.2614 4.68811 13.8319 5.01631 13.4674C5.37466 13.0695 5.87233 12.7754 7.06731 12.0855L24.05 2.28053Z",
    stroke: "url(#paint1_linear_2236_5512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.05 2.28053C25.245 1.59061 25.7485 1.30663 26.2723 1.19529C26.7521 1.09331 27.2479 1.09331 27.7277 1.19529C28.2515 1.30663 28.755 1.59061 29.95 2.28053L46.9327 12.0855C48.1277 12.7754 48.6253 13.0695 48.9837 13.4674C49.3119 13.8319 49.5598 14.2614 49.7114 14.7278C49.8769 15.2372 49.8827 15.8152 49.8827 17.195L49.8827 36.805C49.8827 38.1848 49.8769 38.7628 49.7114 39.2722C49.5598 39.7386 49.3119 40.1681 48.9837 40.5326C48.6253 40.9305 48.1277 41.2246 46.9327 41.9145L29.95 51.7195C28.755 52.4094 28.2515 52.6934 27.7277 52.8047C27.2479 52.9067 26.7521 52.9067 26.2723 52.8047C25.7485 52.6934 25.245 52.4094 24.05 51.7195L7.06731 41.9145C5.87233 41.2246 5.37466 40.9305 5.01631 40.5326C4.68811 40.1681 4.44018 39.7386 4.28862 39.2722C4.12312 38.7628 4.11731 38.1848 4.11731 36.805L4.11731 17.195C4.11731 15.8152 4.12312 15.2372 4.28862 14.7278C4.44018 14.2614 4.68811 13.8319 5.01631 13.4674C5.37466 13.0695 5.87233 12.7754 7.06731 12.0855L24.05 2.28053Z",
    stroke: "url(#paint2_linear_2236_5512)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_2236_5512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 27C37 21.48 32.52 17 27 17C21.48 17 17 21.48 17 27C17 31.84 20.44 35.87 25 36.8V30H23V27H25V24.5C25 22.57 26.57 21 28.5 21H31V24H29C28.45 24 28 24.45 28 25V27H31V30H28V36.95C33.05 36.45 37 32.19 37 27Z",
    fill: "url(#paint3_linear_2236_5512)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2236_5512",
    x: -20.3826,
    y: -23.3811,
    width: 94.7651,
    height: 100.762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2236_5512"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2236_5512",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_2236_5512",
    x: 17,
    y: 17,
    width: 20,
    height: 19.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2236_5512"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2236_5512",
    result: "effect2_innerShadow_2236_5512"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2236_5512",
    x1: 27,
    y1: 0,
    x2: 27,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F200DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8217F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2236_5512",
    x1: 9.52941,
    y1: 48.8382,
    x2: 49.9664,
    y2: 5.89656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F200DC",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249CFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2236_5512",
    x1: 9.52941,
    y1: 48.8382,
    x2: 49.9664,
    y2: 5.89656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2236_5512",
    x1: 17.398,
    y1: 17.4507,
    x2: 37.1877,
    y2: 37.4031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#EDFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.318184a04d6bd472fbc54f2f7004c725.svg";
export { ForwardRef as ReactComponent };